import React from 'react';
import PropTypes from 'prop-types';

// app
import styles from './AddProductsClient.styles';
import { Form } from 'components';

// mui
import { makeStyles } from '@material-ui/core';

AddProductsClientView.propTypes = {
  fields: PropTypes.array.isRequired,
  actions: PropTypes.array.isRequired,
  defaultValues: PropTypes.object.isRequired,
  validationSchema: PropTypes.object.isRequired,
};

export function AddProductsClientView({ fields, actions, defaultValues, validationSchema }) {
  const classes = makeStyles(styles, { name: 'AddProductsClient' })();

  return (
    <div className={classes.root}>
      <Form
        id="add-products-client"
        type="dialog"
        fields={fields}
        actions={actions}
        defaultValues={defaultValues}
        validationSchema={validationSchema}
      />
    </div>
  );
}
